import React, { VFC } from 'react'
import styled, { css } from 'styled-components'

import { ImageV2 } from '@Components/Image'
import {
  PersonalizationButton,
  PersonalizationCaption,
  PersonalizationImage,
  PersonalizationImageContainer,
  PersonalizationItemRoot,
} from '@Components/Personalization/Styles/Personalization.styled'
import { up } from '@Globals/Style/breakpoints'

interface Props {
  buttonText: string
  caption: string
  image: string
  onClick: () => void
}

const Caption = styled(PersonalizationCaption)`
  order: 2;

  ${up('tablet')} {
    order: unset;
  }
`

const Button = styled(PersonalizationButton)(({ theme }) => css`
  border-color: ${theme.colors.greyDark};
  border-width: 1px;
`)

const PersonalizationItemLayout: VFC<Props> = ({
  buttonText,
  caption,
  image,
  onClick,
}) => (
  <PersonalizationItemRoot>
    <PersonalizationImageContainer>
      <PersonalizationImage>
        <ImageV2
          height={200}
          layout="responsive"
          loading="lazy"
          objectFit="contain"
          sizes="200px"
          src={image}
          width={200}
        />
      </PersonalizationImage>
    </PersonalizationImageContainer>
    <Caption center>
      {caption}
    </Caption>
    <Button
      color="dark"
      onClick={onClick}
      variant="outlined"
    >
      {buttonText}
    </Button>
  </PersonalizationItemRoot>
)

export default PersonalizationItemLayout
